import { render, staticRenderFns } from "./RCheckbox.vue?vue&type=template&id=4ee97f85&scoped=true&"
var script = {}
import style0 from "./RCheckbox.vue?vue&type=style&index=0&id=4ee97f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee97f85",
  null
  
)

export default component.exports